export default __webpack_public_path__ + "static/media/PayPal.554a9ad2.svg";